<template>
  <div class="navigation-wrap">
    <!--menu-logo-->
    <div class="navigation-wrap-inner">
      <router-link to="/">
        <img src="@/assets/logo.png" alt="美课教育" class="navigation-logo" />
      </router-link>
      <!--menu-nav-->
      <div class="navigation-college">
        <el-header>
          <el-menu :default-active="this.$route.path" class="el-menu-demo" mode="horizontal" router
            @select="handleSelect">
            <el-menu-item v-for="(item, i) in navList" :key="i" :index="item.name">
              <template slot="title">
                <!-- <i class="el-icon-s-platform"></i> -->
                <span> {{ item.navItem }}</span>
              </template>
            </el-menu-item>
          </el-menu>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
        <!-- <div v-for="(item,index) in navList" :key="index" :class="index == active?'active':''" @mousemove="active = index" @mouseout="active = null" class="college-item"
          @click="toPage(index)">{{ item.name }}
        </div> -->
      </div>
      <!--menu-search-->
      <div class="navigation-search">
        <form class="navigation-searchform">
          <input type="text" placeholder="更多精彩课程由此发现哦~" placeholder-style v-model="searchQuery"
            @keyup.enter="getHttpLogData()">
        </form>
      </div>
      <!--menu-entry-->
      <div class="navigation-entry">
        <div v-if="showlogin" class="login">
          <router-link to="/login">
            <span class="navigation-entryUser">登录 /</span>
          </router-link>
          <router-link to="/login">
            <span class="navigation-entryUser">注册</span>
          </router-link>
        </div>
        <!--      <div class="other-icon" v-if="!showlogin">
          <router-link to="/">
            <h4 class="iconfont icon-xiaoxi"></h4>
            <span>消息</span>
          </router-link>
        </div> -->
        <el-dropdown v-if="!showlogin">
          <div class="userInfo">
            <img :src="userList.avatar_url" />
          </div>
          <el-dropdown-menu slot="dropdown" style="width:100px;">
            <el-dropdown-item>
              <router-link to="/personal" style="color:#606266;">个人中心</router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/PersonalEdit" style="color:#606266;">资料设置</router-link>
            </el-dropdown-item>
            <el-dropdown-item @click.native="quit()">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Menu',
    data() {
      return {
        userList: [],
        active: null,
        navList: [{
            name: '/',
            navItem: '首页'
          },
          {
            name: '/ai',
            navItem: 'AI体验'
          },
          // {
          //   name: '/course',
          //   navItem: '教程区'
          // },
          {
            name: '/circle',
            navItem: '社区'
          },
          {
            name: '/task',
            navItem: '商业订单'
          },
          {
            name: '/curriculum',
            navItem: '正式课'
          }
        ],
        searchQuery: "",
        showlogin: false
      }
    },
    created() {
      this.userInfo()
      this.active = this.$route.query.active

    },
    methods: {
      getHttpLogData() {
        this.$router.push({
          path: "/Search",
          query: {
            "keyVal": this.searchQuery
          }
        })
      },
      userInfo() {
        if (this.$cookieStore.getCookie('userInfo')) {
          this.userList = JSON.parse(this.$cookieStore.getCookie('userInfo'))
        }

        if (this.$cookieStore.getCookie('token')) {
          this.showlogin = false
        } else {
          this.showlogin = true
        }
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath)
      },
      quit() {
        this.$cookieStore.delCookie('token')
        this.$cookieStore.delCookie('userInfo')
        //   跳转到登录页
        this.$router.push("/login")
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    font-size: 12px;
  }

  .other-icon {
    width: 50px;
    text-align: center;
    margin: 0 35px 0 20px;
  }

  .other-icon a {
    color: #a3a8ab
  }

  /deep/ .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #FABE00;
  }

  .userInfo {
    line-height: 45px;
  }

  .userInfo img {
    float: left;
    width: 42px;
    height: 42px;
    border-radius: 60px;
  }

  .login {
    display: -webkit-box;
  }

  .icons-txt {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #a3a8ab;
    margin-top: -4px;
    line-height: 1.5;
  }

  .downlod-app-box {
    display: flex;
    color: #a3a8ab;
    font-size: 12px;
    margin-top: 2px;
  }

  .downlod-app-box a {
    display: none;
    margin-right: 10px;
    width: 47px;
    color: #a3a8ab;
  }

  /*navigation-wrap*/
  .navigation-wrap {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    background: #fff;
    box-shadow: 0 2px 9px 0 rgb(0 0 0 / 8%);
    position: sticky;
    top: 0;
    z-index: 100;
  }

  /*navigation-wrap-inner*/
  .navigation-wrap .navigation-wrap-inner {
    width: 1200px;
    height: 70px;
    display: flex;
    align-items: center;
  }

  /*navigation-logo*/
  .navigation-wrap .navigation-wrap-inner .navigation-logo {
    width: 135px;
    margin-top: 5px;
  }

  /*nav*/
  .navigation-wrap .navigation-college {
    width: 470px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 20px;
  }

  .navigation-college .college-item {
    min-width: 32px;
    max-width: 66px;
    font-size: 16px;
    font-weight: 500;
    color: #a3a8ab;
    cursor: pointer;
  }

  .navigation-college .active {
    color: #fabe00;
    font-weight: 600;
  }

  /*navigation-input*/
  .navigation-search {
    width: 300px;
    margin-left: 50px;
  }

  .navigation-search .navigation-searchform {
    align-items: center;
    z-index: 1;
    overflow: hidden;
    line-height: 35px;
    border: 1pxsolidvar(--line_regular);
    opacity: .9;
  }

  .navigation-search .navigation-searchform input {
    background-color: #f1f2f3;
    width: 100%;
    height: 35px !important;
    border: none;
    border-radius: 8px;
    outline: none;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: "tnum";
    display: inline-block;
    width: 100%;
    padding: 2px 11px;
    color: rgba(0, 0, 0, .65);
    font-size: 14px;
    background-image: none;
    transition: all .3s;
  }

  /* navigation-entry */
  .navigation-entry {
    margin-left: 80px;
    display: flex;

    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .navigation-entry a {
    display: block;
    text-decoration: none;
  }

  .navigation-entry .navigation-entryUser {
    /* display: block; */
    font-size: 14px;
    font-weight: 500;
    color: #a3a8ab;
    margin-left: 5px;
    cursor: pointer;
    float: left;

  }

  /* 导航 */
  .el-menu--horizontal>.el-menu-item {
    height: 50px;
    padding: 0;
    margin-right: 40px;
  }

  .el-menu.el-menu--horizontal {
    border: none;
  }

  /* 头像弹出框 */
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/Menu/index.vue